<div class="provision-button">
    <fui-commands [title]="title">
        <fui-command [title]="title"
                     (clicked$)="clicked.emit($event)"></fui-command>
    </fui-commands>
</div>
